const papersDataEdexcelIgcse = {
  mathematics: [
    {
      year: '2023',
      papers: [
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4ma1-1h-que-20230111.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4ma1-1h-rms-20230302.pdf',
        },
        {
          label: '1HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4ma1-1hr-que-20230111.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4ma1-1hr-rms-20230302.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4ma1-2h-que-20230118.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4ma1-2h-rms-20230302.pdf',
        },
        {
          label: '2HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4ma1-2hr-que-20230118.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4ma1-2hr-rms-20230302.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_que_20220111.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_rms_20220303.pdf',
        },
        {
          label: '1HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_que_20220111.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_rms_20220303.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_que_20220118.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_rms_20220303.pdf',
        },
        {
          label: '2HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_que_20220118.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_rms_20220303.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/Exam-materials/4MA1_1H_que_20210420.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_rms_20210604.pdf',
        },
        {
          label: '1HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_msc_20210304.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/Exam-materials/4MA1_2H_que_20210430.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_rms_20210604.pdf',
        },
        {
          label: '2HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_que_20210304.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_msc_20210304.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_rms_20200305.pdf',
        },
        {
          label: '1HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_rms_20200305.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_rms_20200305.pdf',
        },
        {
          label: '2HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_que_20200305-.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_rms_20200305.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1H_rms_20200305.pdf',
        },
        {
          label: '1HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_1HR_rms_20200305.pdf',
        },
        {
          label: '2H',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2H_rms_20200305.pdf',
        },
        {
          label: '2HR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_que_20200305-.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Mathematics%20A/2016/exam-materials/4MA1_2HR_rms_20200305.pdf',
        },
      ],
    },
  ],
  physics: [
    {
      year: '2023',
      papers: [
        {
          label: '1P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-1p-que-20230526.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-1p-rms-20230824.pdf',
        },
        {
          label: '1PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-1pr-que-20230526.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-1pr-rms-20230824.pdf',
        },
        {
          label: '2P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-2p-que-20230617.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-2p-rms-20230824.pdf',
        },
        {
          label: '2PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-2pr-rms-20230824.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Physics/2017/Exam-materials/4ph1-2pr-que-20230617.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-1p-que-20220610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-1p-rms-20220825.pdf',
        },
        {
          label: '1PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-1pr-que-20220610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-1pr-rms-20220825.pdf',
        },
        {
          label: '2P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-2p-que-20220624.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-2p-rms-20220825.pdf',
        },
        {
          label: '2PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-2pr-que-20220624.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-2pr-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1P_que_20210428.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1P_rms_20210604.pdf',
        },
        {
          label: '2P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4ph1-2p-que-20210430.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2P_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1P_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1P_rms_20200305.pdf',
        },
        {
          label: '1PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1PR_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1PR_rms_20200305.pdf',
        },
        {
          label: '2P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2P_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2P_rms_20200305.pdf',
        },
        {
          label: '2PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2PR_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2PR_rms_20200305.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1P_que_20190523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1P_rms_20190822.pdf',
        },
        {
          label: '1PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1PR_que_20190523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_1PR_rms_20190822.pdf',
        },
        {
          label: '2P',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2P_que_20190615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2P_rms_20190822.pdf',
        },
        {
          label: '2PR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2PR_que_20190615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Physics/2017/exam-materials/4PH1_2PR_rms_20190822.pdf',
        },
      ],
    },
  ],
  chemistry: [
    {
      year: '2023',
      papers: [
        {
          label: '1C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-1c-que-20230523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-1c-rms-20230824.pdf',
        },
        {
          label: '1CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-1cr-que-20230523.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-1cr-rms-20230824.pdf',
        },
        {
          label: '2C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-2c-que-20230614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-2c-rms-20230824.pdf',
        },
        {
          label: '2CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-2cr-que-20230614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Chemistry/2017/Exam-materials/4ch1-2cr-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-1c-que-20220528.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-1c-rms-20220825.pdf',
        },
        {
          label: '1CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-1cr-que-20220528.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-1cr-rms-20220825.pdf',
        },
        {
          label: '2C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-2c-que-20220621.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-2c-rms-20220825.pdf',
        },
        {
          label: '2CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-2cr-que-20220621.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4ch1-2cr-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1C_que_20210428.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1C_rms_20210604.pdf',
        },
        {
          label: '2C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/Exam-materials/4CH1_2C_que_20210429.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2C_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1C_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1C_rms_20200305.pdf',
        },
        {
          label: '1CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1CR_que_20200305-.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1CR_rms_20200305.pdf',
        },
        {
          label: '2C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2C_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2C_rms_20200305.pdf',
        },
        {
          label: '2CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2CR_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2CR_rms_20200305.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1C_que_20190520.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1-1C-msc-20190822-V2.pdf',
        },
        {
          label: '1CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1CR_que_20190517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_1CR_rms_20190822.pdf',
        },
        {
          label: '2C',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2C_que_20190613.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2C_rms_20190822.pdf',
        },
        {
          label: '2CR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2CR_que_20190613.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Chemistry/2017/exam-materials/4CH1_2CR_rms_20190822.pdf',
        },
      ],
    },
  ],
  biology: [
    {
      year: '2023',
      papers: [
        {
          label: '1B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-1b-que-20230517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-1b-rms-20230824.pdf',
        },
        {
          label: '1BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-1br-que-20230517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-1br-rms-20230824.pdf',
        },
        {
          label: '2B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-2b-que-20230610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-2b-rms-20230824.pdf',
        },
        {
          label: '2BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-2br-que-20230610.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Biology/2017/Exam-materials/4bi1-2br-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-1b-que-20220518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-1b-rms-20220825.pdf',
        },
        {
          label: '1BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-1br-que-20220518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-1br-rms-20220825.pdf',
        },
        {
          label: '2B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-2b-que-20220616.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-2b-rms-20220825.pdf',
        },
        {
          label: '2BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-2br-que-20220616.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4bi1-2br-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1B_que_20210427.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1B_rms_20210604.pdf',
        },
        {
          label: '2B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/Exam-materials/4BI1_2B_que_20210428.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2B_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1B_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1B_rms_20200305.pdf',
        },
        {
          label: '1BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1BR_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1BR_rms_20200305.pdf',
        },
        {
          label: '2B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2B_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2B_rms_20200305.pdf',
        },
        {
          label: '2BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2BR_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2BR_rms_20200305.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1B_que_20190515.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1B_rms_20190822.pdf',
        },
        {
          label: '1BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1BR_que_20190515.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_1BR_rms_20190822.pdf',
        },
        {
          label: '2B',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2B_que_20190608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2B_rms_20190822.pdf',
        },
        {
          label: '2BR',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2BR_que_20190608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Biology/2017/exam-materials/4BI1_2BR_rms_20190822.pdf',
        },
      ],
    },
  ],
  englishlanguage: [
    {
      year: '2023',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01-que-20230113.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01-rms-20230302.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01r-que-20230113.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01r-rms-20230302.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02-que-20230120.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02-rms-20230302.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02r-que-20230120.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02r-rms-20230302.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01-que-20220519.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01-rms-20220825.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01r-que-20220519.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-01r-rms-20220825.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02-que-20220611.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02-rms-20220825.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02r-que-20220611.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02r-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01_que_20210427.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01_rms_20210604.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4ea1-02-que-20210505.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01_rms_20200305.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01R_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01R_rms_20200305.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02_rms_20200305.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02R_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02R_rms_20200305.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01_que_20190605.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01_rms_20190822.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01R_que_20190605.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_01R_rms_20190822.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02_que_20190608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02__rms_20190822.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02R_que_20190608.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/English%20Language%20A/2016/exam-materials/4EA1_02R_rms_20190822.pdf',
        },
      ],
    },
  ],
  businessstudies: [
    {
      year: '2023',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-01-que-20230518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-01-rms-20230824.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-01r-que-20230518.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-01r-rms-20230824.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-02-que-20230613.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-02-rms-20230824.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-02r-que-20230613.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Business/2017/Exam-materials/4bs1-02r-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4bs1-01-que-20220520.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4bs1-01-rms-20220825.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4bs1-01r-que-20220520.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4bs1-01r-rms-20220825.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4bs1-02-que-20220614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02_rms_20220825.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4bs1-02r-que-20220614.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4bs1-02r-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/Exam-materials/4BS1_01_que_20210430.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01_rms_20210604.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/Exam-materials/4BS1_02_que_20210511.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01_que_20201110.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01_msc_20210211.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01R_que_20201110.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01R_msc_20210211.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02_que_20201117.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02_msc_20210211.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02R_que_20201117.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02R_msc_20210211.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01_que_20190517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01_rms_20190822.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01R_que_20190517.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_01R_rms_20190822.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02_que_20190525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02_rms_20190822.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02R_que_20190525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Business/2017/Exam-materials/4BS1_02R_rms_20190822.pdf',
        },
      ],
    },
  ],
  economics: [
    {
      year: '2023',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-01-que-20230525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-01-rms-20230824.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-01r-que-20230525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-01r-rms-20230824.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-02-que-20230615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-02-rms-20230824.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-02r-que-20230615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International-GCSE/Economics/2017/Exam-materials/4ec1-02r-rms-20230824.pdf',
        },
      ],
    },
    {
      year: '2022',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-01-que-20220525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-01-rms-20220825.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-01r-que-20220525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-01r-rms-20220825.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-02-que-20220615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-02-rms-20220825.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-02r-que-20220615.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4ec1-02r-rms-20220825.pdf',
        },
      ],
    },
    {
      year: '2021',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/Exam-materials/4EC1_01_que_20210426.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01_rms_20210604.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/Exam-materials/4EC1_02_que_20210504.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02_rms_20210604.pdf',
        },
      ],
    },
    {
      year: '2020',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01_rms_20200305.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01R_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01R_rms_20200305.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02_rms_20200305.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02R_que_20200305.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02R_rms_20200305.pdf',
        },
      ],
    },
    {
      year: '2019',
      papers: [
        {
          label: '1',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01_que_20190525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01_rms_20190822.pdf',
        },
        {
          label: '1R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01R_que_20190525.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_01R_rms_20190822.pdf',
        },
        {
          label: '2',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02_que_20190604.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02_rms_20190822.pdf',
        },
        {
          label: '2R',
          link:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02R_que_20190604.pdf',
          marking:
            'https://qualifications.pearson.com/content/dam/pdf/International%20GCSE/Economics/2017/exam-materials/4EC1_02R_rms_20190822.pdf',
        },
      ],
    },
  ],
};

export default papersDataEdexcelIgcse;
